export class WebClient {
    constructor(url) {
        this._apiUrl = new URL(url).href;
    }
    get baseUrl() {
        return this._apiUrl;
    }
    static create(options) {
        if (WebClient._instance !== undefined &&
            WebClient._instance instanceof WebClient) {
            return WebClient._instance;
        }
        const client = new WebClient(options.baseUrl);
        WebClient._instance = client;
        return client;
    }
}
WebClient._instance = undefined;
export function createWebClient(options) {
    return WebClient.create(options);
}
